// Ancoragem da conversa no fim. O painel de mensagens tem que abrir mostrando
// a mensagem mais recente e continuar assim quando chegam novas — mas sem
// arrastar de volta para baixo quem subiu para ler o histórico.

export interface MetricasDeRolagem {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
}

// Folga em px: o navegador devolve scrollTop fracionado (zoom, DPI) e
// avatar/anexo carregando muda a altura por alguns pixels.
export const LIMIAR_DO_FIM = 80;

export const posicaoDoFim = ({ scrollHeight, clientHeight }: MetricasDeRolagem): number =>
  Math.max(0, scrollHeight - clientHeight);

export const estaNoFim = (metricas: MetricasDeRolagem, limiar = LIMIAR_DO_FIM): boolean =>
  posicaoDoFim(metricas) - metricas.scrollTop <= limiar;

// Salto até a mensagem citada numa resposta. A original pode estar na tela,
// escondida atrás do "Ver histórico completo" ou numa página ainda não
// carregada — aí é preciso buscar páginas antigas até achá-la. `tentativas`
// conta páginas já pedidas; `semNovidade` diz que a última busca não trouxe
// nada (acabou o histórico, ou a mensagem foi removida de vez).
export const MAX_PAGINAS_NO_SALTO = 10;

export type PassoDoSalto = 'rolar' | 'carregar' | 'desistir';

export const proximoPassoDoSalto = (
  alvoId: string,
  idsCarregados: readonly string[],
  tentativas: number,
  semNovidade: boolean,
  maxPaginas = MAX_PAGINAS_NO_SALTO
): PassoDoSalto => {
  if (idsCarregados.includes(alvoId)) return 'rolar';
  if (semNovidade || tentativas >= maxPaginas) return 'desistir';
  return 'carregar';
};
